var _defs, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440.47 422.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e0e0;}.cls-2{fill:#ebebeb;}.cls-3{fill:#fafafa;}.cls-4{fill:#263238;}.cls-5{fill:#fff;}.cls-6{fill:#455a64;}.cls-7{fill:#ff725e;}.cls-8{fill:#ffbe9d;}.cls-9{fill:#eb996e;}.cls-10{opacity:0.4;}.cls-11,.cls-12{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.33,299.38s-9.65-6.73-14.08-5.51-10.11,7.45-10.11,7.45,11.24-3.24,14.63-2.56A63.3,63.3,0,0,0,181.33,299.38Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.58,301.81c-1.41,3.18-3.83,5.83-5.19,9a15.25,15.25,0,0,0-.07,11.59,20.84,20.84,0,0,0,4.92-9.87,54.08,54.08,0,0,0,1.13-10.32Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.1,301c.44-1.3-10.48-.73-14,3.48s-7,8.79-4,19.42c0,0,6.59-11.52,6.59-11.35S182.22,303.54,183.1,301Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.18,300.85c-1,.39,8.91,3.41,13.49,3.78a13.94,13.94,0,0,0,7.35-1.16S197.37,295.34,183.18,300.85Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.31,342.66s4.78-2,6.13-.6,6.86,8.66,12.09,9.11c0,0-4.78-10.16-9.11-11.8C239.57,338.29,233.31,342.66,233.31,342.66Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.54,342.11s-.19-3.59-2-5.48-8.3-3.17-8.3-3.17A25.34,25.34,0,0,0,229,339,26.8,26.8,0,0,0,234.54,342.11Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.54,341.9s-3.33,0-5.68,4.11a34.19,34.19,0,0,0-3.44,9c.2-.35,6.28-3,7.88-6.38A14.05,14.05,0,0,0,234.54,341.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.29,341.9s.6,7.92,1.94,9.27,3.29,6.27,3.29,6.27,3-7.17,1.34-10.6S235.29,341.9,235.29,341.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.27,357.2c-.38.57-8,6.51-9.19,9.39s-.19,7.28,0,8.62,6.89-1.73,8-6.9A59.66,59.66,0,0,0,206.27,357.2Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.77,352.75c0,.95.11,10.34,2.58,13.62a43.92,43.92,0,0,0,7,6.76s1.62-11.87-1.8-15.54A18.54,18.54,0,0,0,207.77,352.75Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.64,354.36c-.56-.13-7.49-.79-10.79,3.16a36.69,36.69,0,0,0-5.14,8.43s10.48-5.2,12.4-7.5S206.64,354.36,206.64,354.36Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.41,350.06a5.46,5.46,0,0,1,5.94-.15c3.11,1.94,8.29,9.48,8.29,9.48S219.3,359,216,355.8A21.76,21.76,0,0,1,211.41,350.06Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.9,351.23s-4-3.42-7.09-4.18-12.07,1.48-12.07,1.48a16.12,16.12,0,0,0,10.44,2.7C204.41,350.69,206.9,351.23,206.9,351.23Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.56,386s-2.88,5.56,0,8.63,4.42,9.2,4.42,9.2,5-4.8,2.48-10.16A17.39,17.39,0,0,0,193.56,386Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189,386.14c-.77.39-5.75,7.09-6.13,11.88s-.77,13,0,12.46,6.32-5.75,7.85-10.73S189,386.14,189,386.14Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.07,385.62c-.76.19-8-1.15-12.07,4a64.09,64.09,0,0,0-7.09,12.65s10.54-5.39,13-8.35S187.07,385.62,187.07,385.62Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.2,376.42s-2.19,6.52,0,12.27a56.1,56.1,0,0,0,4.68,9.58s3.24-11.5,1.14-14.57S228.2,376.42,228.2,376.42Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.4,375.73c.77.72,9.76,13.62,15.87,14.77s.95-.49.95-.49-1.92-8.69-4.66-12.29S229.4,375.73,229.4,375.73Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228,375.5s6.63-4.6,9.22-5.77,11.17.37,11.17.37S238,375.52,235.5,375s-7.47,1.64-7.47,1.64",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.08,312.77s-5.74,6.09-5,10.85a56,56,0,0,0,2.46,9.32l2.52-8.37Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.86,311.55s-1.33,9.33,1.33,13.13,6.28,11,6.66,10.47,5.9-5.52,1.91-12.56A36.19,36.19,0,0,0,251.86,311.55Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.93,313.2s-9.18-2.66-10.5,1.72S237,323.1,237,323.1a36,36,0,0,1,6.48-5.35A66.12,66.12,0,0,0,249.93,313.2Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.76,315.67l.75-.65c2.17-1.85,8.5-6.94,11.7-6.16a67.28,67.28,0,0,1,9.26,3.37S216.6,319.43,208.76,315.67Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.62,315.73c0-.69-4.17-1.8-7.86,2s-4.25,6.15-4.25,6.15S210.36,322.3,210.62,315.73Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210,316.5s-4.22,4.85-1,9.61,6,9.33,6,9.33a15.41,15.41,0,0,0,0-9.47A34,34,0,0,0,210,316.5Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.74,328.58c-.19-1.16,1.34-10.66-11.23-9.72h-1.15s6,9.7,7.39,12.75a13.22,13.22,0,0,0,3.89,5.33C226.12,338.27,225.93,329.74,225.74,328.58Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.17,376a10.92,10.92,0,0,0-3-8.11c-.19-.21-.47-.42-.72-.3a.7.7,0,0,0-.31.45,7,7,0,0,0,.7,5.22,17.71,17.71,0,0,0,3.4,4.18",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.75,384.79a21.5,21.5,0,0,0-10.19-9.32,1.42,1.42,0,0,0-.85-.17,1.1,1.1,0,0,0-.77,1,3.59,3.59,0,0,0,1,2.54,17.85,17.85,0,0,0,11.32,6.77",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.11,370.76s-.64,0-1.8.18a20,20,0,0,0-4.74,1.23,27.32,27.32,0,0,0-6.33,3.56,67.35,67.35,0,0,0-6.68,5.93c-4.57,4.45-8.6,8.57-11.39,11.67-1.39,1.55-2.5,2.82-3.26,3.71l-.89,1c-.2.23-.31.35-.33.34a2.06,2.06,0,0,1,.26-.4c.19-.24.46-.61.82-1.06.72-.92,1.79-2.23,3.16-3.81,2.74-3.16,6.74-7.34,11.31-11.78a61.79,61.79,0,0,1,6.75-5.95,26.86,26.86,0,0,1,6.47-3.53,18.42,18.42,0,0,1,4.84-1.09,11.81,11.81,0,0,1,1.34,0A2.15,2.15,0,0,1,243.11,370.76Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.45,395.63c-.07.05-.82-1.25-2.45-3a20.8,20.8,0,0,0-16.72-6.56c-2.38.16-3.81.6-3.83.52a3.89,3.89,0,0,1,1-.34,17.16,17.16,0,0,1,2.81-.5,20,20,0,0,1,17,6.66,16.62,16.62,0,0,1,1.72,2.29A4.24,4.24,0,0,1,207.45,395.63Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.92,315.6a1.48,1.48,0,0,1,0,.28c0,.2,0,.47-.07.8-.07.73-.17,1.76-.3,3.07-.27,2.66-.66,6.52-1.09,11.29-.84,9.53-1.84,22.74-1.82,37.35s1.07,27.82,1.81,37.36c.39,4.75.7,8.61.92,11.31.1,1.31.18,2.34.24,3.07,0,.33,0,.6.05.8a1,1,0,0,1,0,.28,1.45,1.45,0,0,1-.05-.27c0-.21,0-.47-.09-.8-.08-.73-.19-1.76-.32-3.07-.27-2.66-.65-6.52-1.07-11.29-.82-9.54-1.9-22.75-2-37.39s1-27.85,2-37.38c.47-4.77.91-8.62,1.23-11.28q.25-2,.39-3.06l.12-.8A.84.84,0,0,1,209.92,315.6Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.58,341.32a6.45,6.45,0,0,1-1.34.21c-.86.09-2.11.26-3.64.5a67.67,67.67,0,0,0-22.73,8c-1.35.76-2.42,1.41-3.16,1.88a6.48,6.48,0,0,1-1.17.67,8,8,0,0,1,1.08-.82c.7-.51,1.76-1.2,3.09-2a60.73,60.73,0,0,1,22.84-8c1.55-.2,2.8-.32,3.67-.36A7.82,7.82,0,0,1,238.58,341.32Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.55,337.08a4.11,4.11,0,0,1-.12-.51c-.07-.39-.15-.88-.26-1.48a20.88,20.88,0,0,0-.46-2.32c-.23-.89-.4-1.93-.79-3-.18-.55-.36-1.13-.55-1.73s-.46-1.2-.7-1.84c-.47-1.28-1.13-2.58-1.79-4a51.78,51.78,0,0,0-5.47-8.31A64.56,64.56,0,0,0,184,301.77c-.93-.69-1.84-1.21-2.61-1.73s-1.46-.91-2-1.24L178.1,298a2.53,2.53,0,0,1-.43-.29,2,2,0,0,1,.48.21l1.32.71c.58.3,1.28.68,2.06,1.18s1.71,1,2.67,1.67a61.52,61.52,0,0,1,13.56,12.11,50.23,50.23,0,0,1,5.49,8.41,41.11,41.11,0,0,1,1.77,4c.23.65.51,1.25.68,1.87s.36,1.19.53,1.75a30.92,30.92,0,0,1,.73,3.07,17.45,17.45,0,0,1,.39,2.34c.07.61.13,1.1.17,1.49A1.77,1.77,0,0,1,207.55,337.08Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.52,312.33a2.16,2.16,0,0,1-.48.22l-1.41.53c-1.23.44-3,1.11-5.16,2A153.8,153.8,0,0,0,229,322.84a152,152,0,0,0-15.38,9.75c-1.9,1.36-3.41,2.49-4.44,3.29l-1.2.91a2.65,2.65,0,0,1-.44.29s.12-.14.38-.37l1.15-1c1-.84,2.48-2,4.36-3.42a132.53,132.53,0,0,1,31.92-17.56c2.18-.83,4-1.46,5.21-1.85l1.44-.45A2.59,2.59,0,0,1,252.52,312.33Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.22 421.57 161.12 421.57 157.35 377.47 201.44 377.47 197.22 421.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 154.55,
    y: 377.47,
    width: 49.82,
    height: 6.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.82,426.78c0,.12-11.15.23-24.88.23s-24.89-.11-24.89-.23,11.14-.23,24.89-.23S232.82,426.65,232.82,426.78Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 384.79,
    y: 426.19,
    width: 30.66,
    height: 38.7,
    transform: "translate(767.98 851.67) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "374.85 384.93 374.3 422.4 369.46 422.36 370.49 384.89 374.85 384.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "338.57 384.64 356.17 384.78 386.82 385.02 356.13 389.06 355.87 422.25 338.29 422.12 338.57 384.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "348.15 384.72 347.45 422.19 342.23 422.15 343.08 384.68 348.15 384.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.83,415.83c0,.23-.5.48-1.44.71a24.61,24.61,0,0,1-7,.51c-.52,0-1.07-.1-1.63-.19a12,12,0,0,1-1.79-.38,5.26,5.26,0,0,1-1.1-.47,3.43,3.43,0,0,1-1.17-1.1,3.29,3.29,0,0,1-.5-1.68,5.16,5.16,0,0,1,.15-1.3,22.28,22.28,0,0,1,1.17-3.89,10.72,10.72,0,0,1,1.12-2,9.06,9.06,0,0,1,.76-.9,5.55,5.55,0,0,1,1-.82,4.1,4.1,0,0,1,1.39-.56,3.55,3.55,0,0,1,1.59,0,5.27,5.27,0,0,1,2.1,1.16,17,17,0,0,1,4,4.94,12,12,0,0,1,1.35,4c.12,1,0,1.57-.22,1.63-.5.11-1.22-1.86-3.17-4.34a19.88,19.88,0,0,0-3.94-3.77,2.16,2.16,0,0,0-.89-.46.32.32,0,0,0-.17,0,1.15,1.15,0,0,0-.26.14,2.77,2.77,0,0,0-.39.34,6,6,0,0,0-.43.54,7.23,7.23,0,0,0-.74,1.35,24.37,24.37,0,0,0-1.06,3.29,2.67,2.67,0,0,0-.09.48v0h0l-.09,0c-.11,0-.14.06-.07,0l.12-.09v0a.38.38,0,0,0,.09.08,2.16,2.16,0,0,0,.44.23,14,14,0,0,0,1.36.41c.48.13,1,.23,1.41.32.92.19,1.8.32,2.61.43,1.63.22,3,.36,3.93.54S390.83,415.59,390.83,415.83Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M390.2,416.11c-.08-.49,2.21-1.21,5.79-2.26a49.31,49.31,0,0,0,6-2.16,5.93,5.93,0,0,0,1.31-.73c.14-.11.2-.22.18-.21s0,.14,0,.07a2.74,2.74,0,0,0-.22-.53c-.14-.31-.29-.61-.44-.92a15.31,15.31,0,0,0-.93-1.66,6.83,6.83,0,0,0-1.09-1.31,7,7,0,0,0-.62-.49,2.8,2.8,0,0,0-.56-.3,1.39,1.39,0,0,0-.9-.09,3.08,3.08,0,0,0-1.09.63,24,24,0,0,0-4.19,4.55c-2.05,2.93-2.59,5.21-3.1,5.14-.23,0-.4-.66-.32-1.78a13.1,13.1,0,0,1,1.33-4.57,19.93,19.93,0,0,1,4.2-5.71,6.2,6.2,0,0,1,2.17-1.38,4.65,4.65,0,0,1,3,.05,6.6,6.6,0,0,1,1.28.62,9.35,9.35,0,0,1,2.71,2.75,15.3,15.3,0,0,1,1.14,2.07l.45,1a5.57,5.57,0,0,1,.45,1.41,3.16,3.16,0,0,1-.34,2,3.79,3.79,0,0,1-1.14,1.25,8.26,8.26,0,0,1-2.09,1,31.18,31.18,0,0,1-6.72,1.61C392.64,416.69,390.28,416.55,390.2,416.11Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 361.81,
    y: 414.48,
    width: 45.07,
    height: 12.81,
    transform: "translate(736.62 802.24) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 378.38,
    y: 414.59,
    width: 40.74,
    height: 12.81,
    transform: "translate(765.43 802.58) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "377.9 372.14 377.62 385.01 372.86 384.91 373.19 372.11 377.9 372.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "344.15 371.94 343.69 384.69 338.46 384.65 338.75 371.84 344.15 371.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 418.66,
    y: 443.01,
    width: 17.37,
    height: 21.93,
    transform: "translate(822.36 868.76) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.56 401.21 400.25 422.44 397.5 422.42 398.09 401.19 400.56 401.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "380 401.05 389.97 401.12 407.35 401.26 389.95 403.55 389.81 422.36 379.84 422.28 380 401.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "385.43 401.09 385.04 422.32 382.08 422.3 382.56 401.06 385.43 401.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.08,437.14c0,.32-1.14.71-3.13.88a11.3,11.3,0,0,1-3.64-.3,2.48,2.48,0,0,1-1.41-1,2,2,0,0,1-.32-1.07,2.94,2.94,0,0,1,.09-.8,12.67,12.67,0,0,1,.67-2.24,6.4,6.4,0,0,1,.66-1.16,3.85,3.85,0,0,1,1.08-1,2.41,2.41,0,0,1,1.86-.32,3.34,3.34,0,0,1,1.28.71,9.43,9.43,0,0,1,2.29,2.89c.94,1.9.8,3.24.5,3.29s-.82-1-1.94-2.36a11.85,11.85,0,0,0-2.23-2.06,1,1,0,0,0-.42-.21h0v0a.21.21,0,0,0-.07.05,1.8,1.8,0,0,0-.4.44,4.09,4.09,0,0,0-.4.72,14.4,14.4,0,0,0-.58,1.82l-.05.22h-.16l-.13,0c-.07,0-.08,0,0,0a.82.82,0,0,0,.17-.15l.05,0h0l0,0a.77.77,0,0,0,.2.11,17.5,17.5,0,0,0,3,.7C420.86,436.58,422.08,436.79,422.08,437.14Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421.72,437.3c-.06-.37,1.23-.87,3.23-1.52a31.28,31.28,0,0,0,3.35-1.29,2.61,2.61,0,0,0,.66-.38c.06,0,.06-.08,0,0a.5.5,0,0,0-.06.26c-.12-.24-.24-.48-.35-.73a9.31,9.31,0,0,0-.51-.9,3.48,3.48,0,0,0-.56-.67,2,2,0,0,0-.55-.39.42.42,0,0,0-.29-.05,1.18,1.18,0,0,0-.51.28,14.22,14.22,0,0,0-2.37,2.46c-1.19,1.58-1.59,2.83-2,2.78s-.61-1.54.36-3.72a11.19,11.19,0,0,1,2.39-3.35,3.74,3.74,0,0,1,1.34-.86,3.06,3.06,0,0,1,1.94,0,4.47,4.47,0,0,1,.79.39,4.36,4.36,0,0,1,.63.48,5.81,5.81,0,0,1,1,1.17,8.82,8.82,0,0,1,.67,1.22l.26.56a4.09,4.09,0,0,1,.28.89,2.17,2.17,0,0,1-.24,1.37,2.37,2.37,0,0,1-.74.81,4.9,4.9,0,0,1-1.26.63,16.6,16.6,0,0,1-3.88.85C423.13,437.81,421.78,437.64,421.72,437.3Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 405.63,
    y: 436.37,
    width: 25.54,
    height: 7.26,
    transform: "translate(804.59 840.75) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 415.02,
    y: 436.44,
    width: 23.08,
    height: 7.26,
    transform: "translate(820.92 840.94) rotate(-179.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "402.29 393.96 402.13 401.25 399.44 401.2 399.62 393.94 402.29 393.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "383.16 393.85 382.9 401.07 379.94 401.05 380.1 393.79 383.16 393.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.74,
    width: 132.38,
    height: 219.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.34,
    width: 132.38,
    height: 219.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.97,
    y: 4.44,
    width: 121.1,
    height: 210.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38.03,
    y: 31.76,
    width: 74.47,
    height: 155.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.79,174.81c-.17-14.53,12.9-28.72,27.29-30.75,6.86-1,14.16.39,20.57-2.24,11.45-4.69,15.09-19.9,26.61-24.41l.52,112.46h-75Z",
    transform: "translate(-28.76 -42.51)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.24,465c0,.15-98.61.27-220.23.27S28.76,465.15,28.76,465s98.59-.26,220.25-.26S469.24,464.86,469.24,465Z",
    transform: "translate(-28.76 -42.51)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M428.6,393.09,222.32,393a11.56,11.56,0,0,1-11.54-11.56l.16-306.07A11.55,11.55,0,0,1,222.5,63.81l206.27.11a11.55,11.55,0,0,1,11.55,11.55l-.17,306.07A11.55,11.55,0,0,1,428.6,393.09Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 188.91,
    y: 44.1,
    width: 214.91,
    height: 274.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M334.27,376.5a8.8,8.8,0,1,1-8.79-8.81A8.79,8.79,0,0,1,334.27,376.5Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 262.32,
    y: 30.83,
    width: 69.08,
    height: 3.64,
    rx: 1.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.43,323.48h0a2.58,2.58,0,0,1-2.58-2.59l.1-195.16a2.58,2.58,0,0,1,2.59-2.58h0a2.59,2.59,0,0,1,2.58,2.58L426,320.89A2.58,2.58,0,0,1,423.43,323.48Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.14,109.1c0,.15-19.94.25-44.53.24s-44.53-.14-44.53-.28,19.94-.25,44.53-.24S370.14,109,370.14,109.1Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.55,114.06l.29,0,.8,0,2.93-.08-.09.1c0-.66,0-1.37,0-2.14,0-.39,0-.76,0-1.23a1.15,1.15,0,0,1,1-.92c.48,0,.89,0,1.41,0a1.16,1.16,0,0,1,1,1.15c0,1,0,2,0,3.11l-.15-.15,3.71,0-.16.16c0-1.49,0-3,0-4.62,0-.39,0-.79,0-1.18a1.15,1.15,0,0,0-.52-.86l-1.62-1.6-1.56-1.54c-.25-.26-.51-.51-.76-.75s-.46-.51-.76-.57a1,1,0,0,0-.83.16c-.22.18-.47.45-.69.67L241.15,105c-.84.87-1.72,1.67-2.35,2.41a2.69,2.69,0,0,0-.18,1.38c0,.46,0,.89,0,1.31,0,.79,0,1.49,0,2.1s0,1,0,1.35a2.86,2.86,0,0,1,0,.49,2.56,2.56,0,0,1,0-.45c0-.36,0-.8,0-1.32l0-2.13c0-.42,0-.86,0-1.33l0-.73a1.55,1.55,0,0,1,.21-.78c.69-.85,1.51-1.59,2.35-2.49l1.32-1.35a9.71,9.71,0,0,1,.72-.71,1.28,1.28,0,0,1,1.09-.22,2,2,0,0,1,.9.65l.76.74,1.57,1.54,1.62,1.6a1.46,1.46,0,0,1,.62,1.08c0,.4,0,.79,0,1.19,0,1.58,0,3.13,0,4.62v.16h-.16l-3.71,0h-.15V114c0-1.08,0-2.11,0-3.11a.86.86,0,0,0-.73-.88c-.42,0-.93,0-1.34,0a.89.89,0,0,0-.79.71c0,.37,0,.81,0,1.18v2.23h-.09l-3,0-.77,0Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M408.63,104.12a.16.16,0,0,0-.11-.05l-8.75,0h-3.32l-.06-.5-.14-1a.15.15,0,0,0-.14-.13h-2.43c-.19,0-.32,0-.32.16s.13.16.32.16l2.22,0,1.24,9.58a.14.14,0,0,0,.15.13l7.14,0h2.68c.23,0,.34,0,.34-.15s-.11-.16-.34-.17l-9.58-.13-.22-1.69,10.06.13h0a.15.15,0,0,0,.15-.12l.74-4,.4-2.16A.14.14,0,0,0,408.63,104.12Zm-12.13.22,11.68.16-1,5.6-7.17,0h-2.71Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M400,114.74a1.23,1.23,0,0,0-.41-.67,1.17,1.17,0,0,0-1.13-.19,1.2,1.2,0,0,0,0,2.26,1.16,1.16,0,0,0,.4.07,1.18,1.18,0,0,0,.73-.25,1.1,1.1,0,0,0,.42-.66.86.86,0,0,0,0-.28A1.29,1.29,0,0,0,400,114.74Zm-1.42,1a.79.79,0,0,1,0-1.48.86.86,0,0,1,.27,0,.83.83,0,0,1,.48.16.87.87,0,0,1,.31.44.75.75,0,0,1,0,.17V115a.45.45,0,0,1,0,.17.87.87,0,0,1-.31.44A.8.8,0,0,1,398.54,115.75Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.36,114.79a1.09,1.09,0,0,0-.4-.66,1.15,1.15,0,0,0-1.13-.2,1.2,1.2,0,0,0,0,2.26,1.16,1.16,0,0,0,.4.07,1.18,1.18,0,0,0,.73-.25,1.1,1.1,0,0,0,.42-.66.87.87,0,0,0,0-.28A.84.84,0,0,0,406.36,114.79Zm-1.41,1a.8.8,0,0,1-.5-.75.78.78,0,0,1,.52-.73.86.86,0,0,1,.27,0,.83.83,0,0,1,.48.16.82.82,0,0,1,.34.61v0a.45.45,0,0,1,0,.17.83.83,0,0,1-.31.44A.8.8,0,0,1,405,115.8Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.52,332.05c0,1.41-1,2.27-2.72,2.27H268v2.1h-.71v-6.66h2.49C271.5,329.76,272.53,330.62,272.52,332.05Zm-.7,0c0-1.07-.7-1.68-2-1.68H268v3.33h1.77C271.12,333.7,271.82,333.09,271.82,332.05Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.51,331.42v5h-.64v-.91a2,2,0,0,1-1.8,1,1.94,1.94,0,0,1-2.11-2.15v-2.9h.68v2.83a1.39,1.39,0,0,0,1.5,1.61,1.63,1.63,0,0,0,1.7-1.82v-2.62Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.92,331.39V332h-.16a1.62,1.62,0,0,0-1.69,1.85v2.54h-.67v-5h.65v1A1.91,1.91,0,0,1,282.92,331.39Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.58,333.92a2.46,2.46,0,0,1,2.58-2.53,2.18,2.18,0,0,1,2,1l-.51.34a1.7,1.7,0,0,0-1.45-.74,1.95,1.95,0,0,0,0,3.89,1.66,1.66,0,0,0,1.45-.73l.51.35a2.22,2.22,0,0,1-2,1A2.47,2.47,0,0,1,283.58,333.92Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294,333.53v2.9h-.67V333.6a1.4,1.4,0,0,0-1.5-1.6,1.64,1.64,0,0,0-1.75,1.8v2.63h-.68v-7.06H290v2.93a2.11,2.11,0,0,1,1.87-.91A1.92,1.92,0,0,1,294,333.53Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.58,333.33v3.1h-.64v-.78a1.88,1.88,0,0,1-1.72.83c-1.13,0-1.83-.59-1.83-1.46s.5-1.41,1.93-1.41h1.59v-.31c0-.85-.48-1.32-1.42-1.32a2.56,2.56,0,0,0-1.66.59l-.3-.5a3.14,3.14,0,0,1,2-.68A1.78,1.78,0,0,1,299.58,333.33Zm-.68,1.6v-.82h-1.57c-1,0-1.28.38-1.28.9s.46.94,1.26.94A1.6,1.6,0,0,0,298.9,334.93Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.72,335.86l.3-.53a3,3,0,0,0,1.78.56c.95,0,1.34-.32,1.34-.81,0-1.31-3.24-.28-3.24-2.26,0-.82.7-1.42,2-1.42a3.4,3.4,0,0,1,1.76.46l-.29.55a2.52,2.52,0,0,0-1.47-.43c-.91,0-1.31.35-1.31.82,0,1.35,3.24.34,3.24,2.26,0,.86-.76,1.42-2.06,1.42A3.25,3.25,0,0,1,300.72,335.86Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.41,334.15h-4.18a1.86,1.86,0,0,0,2,1.74,2,2,0,0,0,1.53-.66l.38.44a2.64,2.64,0,0,1-4.55-1.73,2.43,2.43,0,1,1,4.86,0C310.42,334,310.41,334.07,310.41,334.15Zm-4.18-.51h3.55a1.78,1.78,0,0,0-3.55,0Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M321.63,331.44l-1.89,5h-.64l-1.57-4.1-1.58,4.1h-.64l-1.88-5h.65l1.56,4.25,1.61-4.25h.58l1.6,4.25,1.59-4.25Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.27,333.35v3.1h-.64v-.78a1.89,1.89,0,0,1-1.72.82c-1.14,0-1.83-.59-1.83-1.45s.5-1.42,1.93-1.42h1.59v-.3c0-.86-.48-1.32-1.42-1.32a2.51,2.51,0,0,0-1.66.59l-.3-.51a3.14,3.14,0,0,1,2-.67A1.77,1.77,0,0,1,326.27,333.35Zm-.67,1.59v-.81H324c-1,0-1.28.38-1.28.89s.46.94,1.26.94A1.6,1.6,0,0,0,325.6,334.94Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.41,335.88l.31-.53a3,3,0,0,0,1.78.56c.95,0,1.34-.33,1.34-.82,0-1.3-3.24-.28-3.24-2.25,0-.82.7-1.43,2-1.43a3.34,3.34,0,0,1,1.76.47l-.29.54a2.53,2.53,0,0,0-1.48-.43c-.9,0-1.3.35-1.3.83,0,1.35,3.24.33,3.24,2.25,0,.87-.76,1.43-2.06,1.43A3.37,3.37,0,0,1,327.41,335.88Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.56,335.88l.3-.53a3.06,3.06,0,0,0,1.78.56c.95,0,1.34-.32,1.34-.82,0-1.3-3.24-.27-3.24-2.25,0-.82.7-1.43,2-1.43a3.4,3.4,0,0,1,1.76.47l-.29.54a2.6,2.6,0,0,0-1.47-.43c-.91,0-1.31.36-1.31.83,0,1.35,3.25.33,3.24,2.26,0,.86-.76,1.42-2.06,1.42A3.33,3.33,0,0,1,334.56,335.88Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M344.41,331.46v5h-.65v-.92a2,2,0,0,1-1.8,1,1.94,1.94,0,0,1-2.11-2.15v-2.9h.68v2.84a1.4,1.4,0,0,0,1.5,1.6,1.62,1.62,0,0,0,1.7-1.81v-2.62Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.8,334a2.46,2.46,0,0,1,2.57-2.54,2.18,2.18,0,0,1,2,1l-.5.34a1.73,1.73,0,0,0-1.46-.74,2,2,0,0,0,0,3.9,1.72,1.72,0,0,0,1.46-.73l.5.34a2.22,2.22,0,0,1-2,1A2.46,2.46,0,0,1,345.8,334Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.06,334a2.47,2.47,0,0,1,2.58-2.54,2.2,2.2,0,0,1,2,1l-.51.35a1.68,1.68,0,0,0-1.45-.75,2,2,0,0,0,0,3.9,1.69,1.69,0,0,0,1.45-.73l.51.34a2.21,2.21,0,0,1-2,1A2.48,2.48,0,0,1,351.06,334Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.19,334.17H357a1.84,1.84,0,0,0,2,1.74,2,2,0,0,0,1.53-.65l.38.44a2.65,2.65,0,0,1-4.55-1.74,2.41,2.41,0,0,1,2.45-2.53A2.38,2.38,0,0,1,361.2,334S361.19,334.1,361.19,334.17Zm-4.18-.5h3.54a1.77,1.77,0,0,0-3.54,0Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.88,335.9l.31-.54a3,3,0,0,0,1.77.57c1,0,1.34-.33,1.34-.82,0-1.3-3.24-.28-3.24-2.26,0-.81.71-1.42,2-1.42a3.35,3.35,0,0,1,1.77.47l-.29.54A2.53,2.53,0,0,0,364,332c-.9,0-1.3.35-1.3.82,0,1.36,3.24.34,3.24,2.26,0,.86-.76,1.43-2.06,1.42A3.37,3.37,0,0,1,361.88,335.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.53,335.9l.31-.53a3,3,0,0,0,1.77.56c.95,0,1.34-.33,1.34-.82,0-1.3-3.24-.28-3.24-2.25,0-.82.71-1.43,2-1.43a3.35,3.35,0,0,1,1.77.47l-.29.54a2.63,2.63,0,0,0-1.48-.43c-.9,0-1.3.35-1.3.83,0,1.35,3.24.33,3.24,2.25,0,.87-.76,1.43-2.06,1.43A3.37,3.37,0,0,1,366.53,335.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.65,330.88v.59h1.54V332h-1.52v4.43H372V332h-.89v-.57H372v-.62a1.38,1.38,0,0,1,1.51-1.48,1.56,1.56,0,0,1,1,.32l-.23.5a1.14,1.14,0,0,0-.74-.25C373,329.94,372.65,330.26,372.65,330.88Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.61,331.48v5H379v-.92a2,2,0,0,1-1.8,1,1.94,1.94,0,0,1-2.11-2.15v-2.9h.68v2.84a1.4,1.4,0,0,0,1.5,1.6,1.62,1.62,0,0,0,1.7-1.81v-2.62Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.5,329.42h.68v7.06h-.67Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.2,313.32h-3.58v-1.7h9.18v1.7h-3.59v9.12h-2Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M298.26,317.71v4.73h-1.93V318c0-1.47-.73-2.18-2-2.18a2.19,2.19,0,0,0-2.3,2.48v4.18h-1.93V311h1.93v4.17a3.68,3.68,0,0,1,2.75-1.05C296.79,314.09,298.26,315.22,298.26,317.71Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M307.63,317.6v4.84H305.8v-1a2.9,2.9,0,0,1-2.59,1.12c-1.89,0-3.08-1-3.08-2.48s.93-2.45,3.43-2.45h2.14v-.13c0-1.13-.68-1.79-2.06-1.79a4.05,4.05,0,0,0-2.5.82l-.76-1.41a5.79,5.79,0,0,1,3.49-1C306.25,314.09,307.63,315.22,307.63,317.6Zm-1.93,2.26v-1h-2c-1.31,0-1.67.49-1.67,1.1s.59,1.14,1.58,1.14A2.11,2.11,0,0,0,305.7,319.86Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M318.23,317.71v4.73H316.3V318c0-1.47-.73-2.18-2-2.18a2.19,2.19,0,0,0-2.31,2.48v4.18H310.1v-8.26h1.84v1.07a3.58,3.58,0,0,1,2.85-1.16C316.77,314.09,318.23,315.22,318.23,317.71Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.06,318.9l-1.44,1.36v2.18h-1.93V311h1.93v6.92l4-3.71H329l-3.45,3.47,3.77,4.79h-2.35Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.52,314.18l-3.87,8.92c-.75,1.88-1.8,2.45-3.18,2.45a3.4,3.4,0,0,1-2.21-.76l.77-1.42a2.12,2.12,0,0,0,1.42.57c.68,0,1.09-.33,1.46-1.14l.14-.33-3.61-8.29h2l2.6,6.11,2.61-6.11Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.81,318.31a4.4,4.4,0,1,1,4.39,4.24A4.16,4.16,0,0,1,342.81,318.31Zm6.85,0a2.45,2.45,0,1,0-2.46,2.58A2.4,2.4,0,0,0,349.66,318.31Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M361.46,314.18v8.26h-1.84v-1.05a3.38,3.38,0,0,1-2.66,1.16c-2.12,0-3.56-1.16-3.56-3.65v-4.72h1.93v4.46c0,1.5.72,2.21,1.94,2.21a2.18,2.18,0,0,0,2.25-2.49v-4.18Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M363.64,321.34a1.2,1.2,0,0,1,1.25-1.19,1.2,1.2,0,1,1,0,2.4A1.2,1.2,0,0,1,363.64,321.34Zm.1-9.72H366l-.38,7.23h-1.54Z",
    transform: "translate(-28.76 -42.51)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.37,149.6,347.45,191a12.89,12.89,0,0,1-12.86,12h0a12.89,12.89,0,0,1-12.87-13.74c.26-3.94.49-7.16.49-7.16s-10-1.56-10.14-11.57c-.07-5.78.93-18.9,1.79-29a13.12,13.12,0,0,1,13.08-12H333A18.53,18.53,0,0,1,350.37,149.6Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M322.21,182.05a24.22,24.22,0,0,0,13-3.85S332,185.48,322,184.58Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.73,151.09c.18.18,1.27-.62,2.8-.61s2.67.77,2.84.58-.1-.42-.59-.78a4,4,0,0,0-2.27-.7,3.8,3.8,0,0,0-2.23.72C315.81,150.67,315.65,151,315.73,151.09Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.45,155.36a1.43,1.43,0,0,0,1.38,1.44,1.38,1.38,0,0,0,1.47-1.29,1.42,1.42,0,0,0-1.38-1.44A1.36,1.36,0,0,0,329.45,155.36Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.71,155.36a1.43,1.43,0,0,0,1.38,1.44,1.38,1.38,0,0,0,1.48-1.29,1.43,1.43,0,0,0-1.38-1.44A1.37,1.37,0,0,0,315.71,155.36Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.59,151.29c.18.19,1.27-.61,2.8-.61s2.67.78,2.84.59-.1-.42-.6-.78a3.89,3.89,0,0,0-2.26-.7,3.8,3.8,0,0,0-2.23.72C330.67,150.87,330.51,151.21,330.59,151.29Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.12,163.26a10.15,10.15,0,0,0-2.5-.45c-.39,0-.76-.12-.83-.39a2,2,0,0,1,.26-1.16l1.17-3c1.61-4.26,2.78-7.76,2.6-7.83s-1.62,3.34-3.23,7.6c-.39,1.05-.76,2.05-1.11,3a2.27,2.27,0,0,0-.21,1.54,1,1,0,0,0,.65.58,2.88,2.88,0,0,0,.67.09A10,10,0,0,0,325.12,163.26Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.65,164.33c-.25,0-.25,1.65-1.68,2.84s-3.21,1-3.22,1.23.39.33,1.14.35a4.16,4.16,0,0,0,2.69-.94,3.67,3.67,0,0,0,1.31-2.38C330,164.73,329.76,164.32,329.65,164.33Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.69,145.72c.15.41,1.69.22,3.49.43s3.27.71,3.51.34c.1-.18-.15-.58-.74-1a5.86,5.86,0,0,0-2.6-.91,5.8,5.8,0,0,0-2.73.32C331,145.19,330.62,145.52,330.69,145.72Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M315.5,146.44c.27.35,1.33,0,2.6,0s2.36.24,2.6-.13c.11-.18-.06-.53-.53-.86a3.77,3.77,0,0,0-4.19.13C315.53,145.91,315.38,146.27,315.5,146.44Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M347,157.12c.17-.08,6.88-2,6.66,4.81s-7.05,5.21-7.05,5S347,157.12,347,157.12Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M348.78,164.42s.12.08.31.18a1.18,1.18,0,0,0,.89.05,2.92,2.92,0,0,0,1.45-2.6,4,4,0,0,0-.27-1.72,1.41,1.41,0,0,0-.87-1,.62.62,0,0,0-.72.31c-.09.19-.05.32-.09.33s-.14-.11-.08-.4a.8.8,0,0,1,.28-.42,1,1,0,0,1,.67-.15,1.7,1.7,0,0,1,1.21,1.1,4.12,4.12,0,0,1,.35,1.92c-.09,1.38-.83,2.65-1.83,2.9a1.28,1.28,0,0,1-1.09-.21C348.79,164.58,348.76,164.43,348.78,164.42Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.8,156.88a3.59,3.59,0,0,0-3.29,1.69c-.45,1-.54,2.09-1,3.06a2.41,2.41,0,0,1-2.49,1.62,2.12,2.12,0,0,1-1.43-1.56,5.86,5.86,0,0,1,0-2.21c.41-3.2,1.08-6.37,1.21-9.59a16.42,16.42,0,0,0-2-9.3c-1.69-2.74-4.8-4.76-8-4.5-2.13.17-4.08,1.28-6.19,1.57a8.35,8.35,0,0,1-6.95-2.32c-.23-.22-1.3-.93-1.3-.93a4,4,0,0,1,.72-2.12c4.2-3.87,11.75-5,17.29-3.56a19.94,19.94,0,0,1,13.11,10.49c2.38,5.19,1.68,12.41.36,17.66",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.76,139.72a6.55,6.55,0,0,0,5.44,3.52,18,18,0,0,0,6.68-1,53.48,53.48,0,0,1,10.29-1.52c.34,0,.74,0,.92-.28s-.14-.84-.49-1.11c-3-2.34-10.2-3.78-14-3.93a11.12,11.12,0,0,0-9.81,4.65",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M313.74,140a12.85,12.85,0,0,1,7.46-3.37c8.66-.74,22.86,1.92,30.31,16.83a34.13,34.13,0,0,0,1.56-7.92c0-2-1.22-14.16-13.69-18C339.38,127.54,320.58,120.37,313.74,140Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.74,140a12.19,12.19,0,0,1,8.36-3.79c7.74-.35,22.39,3.2,29.41,17.25a34.13,34.13,0,0,0,1.56-7.92c0-2-1.22-14.16-13.69-18C339.38,127.54,320.58,120.37,313.74,140Z",
    transform: "translate(-28.76 -42.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.35,151.32C346.61,145,341,140.71,335,136.94s-16-7.51-22.9-9.33a15,15,0,0,0-6.32-.67,5.71,5.71,0,0,0-4.69,3.84c-.66,2.6,3.95,6.6,6.11,8.17a69.92,69.92,0,0,0,6.57,3.89s-.06-4.83,7.65-5.81C331.89,135.71,350.66,151.59,350.35,151.32Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.36,132.53a27.58,27.58,0,0,0-14.5-3.52,6.84,6.84,0,0,1,2.22-.31,20.14,20.14,0,0,1,10.45,2.54A6.92,6.92,0,0,1,336.36,132.53Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M388.05,295.68c0,.14-25.6.26-57.18.26s-57.18-.12-57.18-.26,25.6-.26,57.18-.26S388.05,295.54,388.05,295.68Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M282,213.86l-14.72,6.65-22.84-18.62-7,11s13,15.05,17.83,20.17,8,7.84,11.83,7.35,25.49-10.71,25.49-10.71S287.47,214.5,282,213.86Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M219.37,192.5s2.87,2.16,4.75,2,9-.17,9.51-.13,7.46,3.81,7.46,3.81l5.08,4.88-8,11.08s-1.31-1.51-2.21-1.4-11.85-.82-13.5-1.38-3.76-.89-4.31-1.9-.67-1.74.84-3c0,0-2-1.57-.56-3.51,0,0-2.28-1.67-1.46-3.21,0,0-1.29-.53-1.5-1.35a8.8,8.8,0,0,1,.09-2.57l3.27-1S217.87,193.64,219.37,192.5Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M218.09,195s.15-.06.42-.14a5.3,5.3,0,0,1,1.22-.25,3,3,0,0,1,1.78.69,2.07,2.07,0,0,1,.68,2.25,1.58,1.58,0,0,1-.89.95,5,5,0,0,1-1.07.31l-1.76.36a5.12,5.12,0,0,1-1.65.21,5.51,5.51,0,0,1,1.57-.56l1.73-.48c.66-.16,1.38-.31,1.58-1a1.64,1.64,0,0,0-.51-1.72,2.83,2.83,0,0,0-1.47-.68,7.38,7.38,0,0,0-1.17.08C218.25,195.09,218.09,195.05,218.09,195Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.19,197.89s.26-.12.76-.22a12.16,12.16,0,0,1,2.16-.24,5.58,5.58,0,0,1,3.16.81,2.75,2.75,0,0,1,1.19,1.64,1.88,1.88,0,0,1-.82,2,5,5,0,0,1-2.07.42l-1.88.15-3.17.22a16.6,16.6,0,0,1-2.94.07,15.83,15.83,0,0,1,2.91-.44l3.16-.33,1.88-.18a5,5,0,0,0,1.85-.36A1.37,1.37,0,0,0,229,200a2.25,2.25,0,0,0-1-1.34,5.43,5.43,0,0,0-2.9-.84C223.32,197.77,222.2,198,222.19,197.89Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229,201.89s.2,0,.41.31a1.6,1.6,0,0,1,.19,1.42,2.43,2.43,0,0,1-1.54,1.44,8.4,8.4,0,0,1-2.48.33c-3.45.16-6.18.83-6.22.68a17.4,17.4,0,0,1,6.19-1.2,9.23,9.23,0,0,0,2.35-.26,2.18,2.18,0,0,0,1.36-1.12,1.51,1.51,0,0,0,0-1.18C229.06,202,228.92,201.93,229,201.89Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M240.29,203.82a3.43,3.43,0,0,1-1.44.56,10.74,10.74,0,0,1-3.74.17,10.62,10.62,0,0,1-3.56-1.15c-.84-.46-1.28-.87-1.24-.92a14.71,14.71,0,0,0,10,1.34Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.89,198.71c.07-.13.78.12,1.66,0s1.52-.49,1.61-.37-.5.78-1.55.89S228.81,198.82,228.89,198.71Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.11,209.64a4,4,0,0,1,1.51-2.76,4.12,4.12,0,0,1,2.85-1.32,22.69,22.69,0,0,0-2.49,1.7A21.47,21.47,0,0,0,228.11,209.64Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.62 195.89 219.06 195.89 227.12 259.41 167.14 259.41 175.62 195.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "219.06 195.89 224.08 195.89 238.9 259.41 227.12 259.41 219.06 195.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "219.06 195.89 224.08 195.89 238.9 259.41 227.12 259.41 219.06 195.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M223.56,205.37s.13-.07.35,0a1.29,1.29,0,0,1,.76.59,1.61,1.61,0,0,1,.14,1.44,2.42,2.42,0,0,1-1.18,1.29,4.93,4.93,0,0,1-2.2.43l.19-.13c-.57,1.09-1.25,1.58-1.3,1.51s.45-.65.9-1.7l.05-.11h.14a5.27,5.27,0,0,0,2-.46,2,2,0,0,0,1-1,1.29,1.29,0,0,0,0-1.09C224.06,205.5,223.54,205.45,223.56,205.37Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M215.42,241.17a6.53,6.53,0,0,1,.1-1.29c.09-.82.26-2,.5-3.48.47-2.93,1.27-7,2.2-11.38s1.79-8.43,2.36-11.34c.26-1.38.49-2.53.66-3.45a6.15,6.15,0,0,1,.3-1.26,6.48,6.48,0,0,1-.1,1.29c-.09.83-.26,2-.5,3.48-.47,2.93-1.27,7-2.21,11.39s-1.78,8.43-2.35,11.34c-.26,1.37-.49,2.53-.66,3.44A5.7,5.7,0,0,1,215.42,241.17Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M238.35,241.81a9.7,9.7,0,0,1-.48-1.46c-.29-1-.67-2.4-1.12-4-.93-3.41-2.17-8.13-3.52-13.35s-2.53-10-3.37-13.4c-.38-1.65-.71-3-1-4.07a8.37,8.37,0,0,1-.28-1.51,9.7,9.7,0,0,1,.48,1.46c.29,1,.67,2.4,1.12,4,.93,3.41,2.17,8.13,3.52,13.36s2.53,9.95,3.36,13.38l1,4.08A8.37,8.37,0,0,1,238.35,241.81Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.67,301.92a11.1,11.1,0,0,1-2.09-1.46c-1.25-.95-3-2.3-4.82-3.81l-.94-.77.38-.06c-1.17,1.76-2.22,3.31-3,4.4a9.22,9.22,0,0,1-1.32,1.7,10.39,10.39,0,0,1,1-1.89c.69-1.14,1.69-2.72,2.85-4.49l.15-.24.23.18.94.76c1.86,1.52,3.53,2.91,4.72,3.94A13,13,0,0,1,267.67,301.92Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.46,238.4c.14,0,2.39,12.78,5,28.6s4.65,28.66,4.5,28.68-2.39-12.78-5-28.6S250.32,238.42,250.46,238.4Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.36,256.43a11.57,11.57,0,0,1-1,1,18.11,18.11,0,0,1-3.31,2.26,19.79,19.79,0,0,1-6,2.06,17.85,17.85,0,0,1-8.36-.49,10.23,10.23,0,0,1-4.2-2.56,7.91,7.91,0,0,1-2.29-4.8,6.24,6.24,0,0,1,2.17-5.23,4.89,4.89,0,0,1,2.81-1.17,5.78,5.78,0,0,1,3.07.64,7.28,7.28,0,0,1,2.45,2,8.22,8.22,0,0,1,1.41,3,14.56,14.56,0,0,1,0,6.63,22.45,22.45,0,0,1-6.82,12,20.35,20.35,0,0,1-6,3.82,14.72,14.72,0,0,1-6.77,1.16,11.55,11.55,0,0,1-6.19-2.4,8.72,8.72,0,0,1-3.3-5.4,8.17,8.17,0,0,1,1.16-5.92,5.6,5.6,0,0,1,4.95-2.67,3.59,3.59,0,0,1,2.45,1.32A5.34,5.34,0,0,1,217.7,264a8.72,8.72,0,0,1-.57,4.89,13.07,13.07,0,0,1-5.57,6.2,19.77,19.77,0,0,1-6,2.16,31,31,0,0,1-4,.5c-.45,0-.8.05-1,.05h-.35l.35,0,1-.1a35.05,35.05,0,0,0,3.95-.6,19.68,19.68,0,0,0,5.85-2.21,12.78,12.78,0,0,0,5.38-6.09,8.36,8.36,0,0,0,.52-4.67,5.08,5.08,0,0,0-1-2.23,3.19,3.19,0,0,0-2.17-1.16,5.13,5.13,0,0,0-4.52,2.5,7.69,7.69,0,0,0-1.08,5.58,8.21,8.21,0,0,0,3.14,5.09,11.09,11.09,0,0,0,5.92,2.28c4.41.34,8.9-1.73,12.33-4.86a21.94,21.94,0,0,0,6.67-11.67,14,14,0,0,0,0-6.4,7.73,7.73,0,0,0-1.3-2.78,6.92,6.92,0,0,0-2.29-1.92,5.35,5.35,0,0,0-2.81-.59,4.5,4.5,0,0,0-2.56,1,5.78,5.78,0,0,0-2,4.84,7.51,7.51,0,0,0,2.15,4.56,9.79,9.79,0,0,0,4,2.49,17.6,17.6,0,0,0,8.2.55,20.25,20.25,0,0,0,5.95-1.95,19.41,19.41,0,0,0,3.34-2.16c.36-.27.61-.51.8-.66A1.22,1.22,0,0,1,250.36,256.43Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.83,194.4H304c-2.52.89-22.85,18.18-22.85,18.18l11.49,18.06,14.9-8.71Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304,194.4l17.3-6.57s2.53,5.31,10.23,4.17,16.79-6.56,16.79-6.56,13.26,7.57,17.18,10.73-3.16,69.32-3.16,69.32l-1.77,19.83s1.39,1,1.39,4.42.13,5.68.13,5.68H293.55s-1.67-7.95-.41-11.11a40.39,40.39,0,0,1,3.35-6.31l1.07-30.56.38-27.28Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.5,196.17s5.53,1.56,7.17,9.76S374,245.45,374,245.45l-30.88-6.69s4.18-13.14,4.18-14,8.5-22.07,8.8-22.52S365.5,196.17,365.5,196.17Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.42,207.28c.14,0,.34,5.47.44,12.23s.06,12.23-.08,12.23-.34-5.47-.44-12.22S297.27,207.28,297.42,207.28Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M351.18,210.22a4.15,4.15,0,0,1-.12,1.08c-.1.7-.28,1.7-.52,2.93-.49,2.46-1.24,5.85-2.22,9.55s-2,7-2.77,9.41c-.4,1.19-.73,2.15-1,2.81a4,4,0,0,1-.44,1,4.89,4.89,0,0,1,.25-1.06c.22-.79.49-1.74.82-2.86.7-2.4,1.65-5.73,2.62-9.43s1.78-7.06,2.36-9.5l.69-2.89A3.7,3.7,0,0,1,351.18,210.22Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M348.28,209.55a39.19,39.19,0,0,1-.07,6.31,39.76,39.76,0,0,1-.59,6.27,36.5,36.5,0,0,1,.07-6.3A38.77,38.77,0,0,1,348.28,209.55Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M340.58,219.9a84.66,84.66,0,0,1-13.26,0,41.59,41.59,0,0,1,6.63-.26A41.59,41.59,0,0,1,340.58,219.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M305.19,264.86l34.17-4.11,5.39-21.64,19.11,4.14s-7.56,30-15.35,32.94-46.34-2-46.34-2Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.8,264.61a41.11,41.11,0,0,0-5.7-1.93c-1.58-.23-3.45.12-3.92.88L285,268.91s-6.81-.65-7.46.88c0,0-4.35-1.24-5.05-.36,0,0-2.18.71-1.82,1.71s8.22,3.76,8.22,3.76L289.66,276s4.11-2.23,5.81-2.41a29.43,29.43,0,0,1,4.9.39c-.14,0,6.3.73,6.3.73s1.31-1.41,1.84-5.29,0-4.69,0-4.69Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M299.23,269.54s-.29,0-.67-.26-.71-.91-1.31-1.32a3.5,3.5,0,0,0-1.18-.36,2.68,2.68,0,0,1-1.47-.65,2.62,2.62,0,0,1-.8-1.62,2.3,2.3,0,0,1,.58-1.86,3.74,3.74,0,0,1,3.43-.94,6,6,0,0,1,2.58,1.32,12.48,12.48,0,0,1,1.37,1.36c.29.34.43.54.41.57s-.75-.68-2-1.64a6.12,6.12,0,0,0-2.45-1.14,3.33,3.33,0,0,0-3,.83,2.08,2.08,0,0,0,.17,2.78c.65.68,1.78.49,2.53,1s.91,1.19,1.24,1.48S299.25,269.5,299.23,269.54Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.53,267.76c0,.08-.52.05-1.25.38a18.89,18.89,0,0,1-2.95,1.4,8.52,8.52,0,0,1-3.29-.26,11.44,11.44,0,0,1-1.32-.19,2.17,2.17,0,0,1,1.36-.17,11.66,11.66,0,0,0,3.13.11c1.14-.29,2.11-1,3-1.23S293.55,267.7,293.53,267.76Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M293.76,272.06a2.15,2.15,0,0,1-.63.4,9.11,9.11,0,0,1-1.89.73,18.57,18.57,0,0,1-6.64.38c-1.28-.16-2.5-.36-3.61-.52a11.15,11.15,0,0,1-2.95-.66,1.87,1.87,0,0,1-.88-.85,1.54,1.54,0,0,1-.13-.91c.11-.53.44-.65.44-.62s-.21.2-.24.64a1.46,1.46,0,0,0,1,1.41,13.06,13.06,0,0,0,2.86.51l3.59.48a20.91,20.91,0,0,0,6.5-.22C292.79,272.47,293.72,272,293.76,272.06Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M345,269.49a38.19,38.19,0,0,0-2.22-4.27,38.88,38.88,0,0,0-3.14-3.65,9.13,9.13,0,0,1,3.57,3.36A9,9,0,0,1,345,269.49Z",
    transform: "translate(-28.76 -42.51)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "61.45 345.07 60.14 411.82 76.31 413.56 87.42 345.59 78.69 334.61 61.45 345.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.05,452.77v1.09s18.4,7.64,18.55,11.14l-36.69-.61V452.17A22.62,22.62,0,0,0,107.05,452.77Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.9,464.39l.17-2.93,35.11,1.66s1.62.74,1.41,1.88Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.53,183.62c-.27-3.08-2.11-6.19-5-7.12l-3.39,1.94a8.15,8.15,0,0,0-4.08,9.9,9.65,9.65,0,0,0-3.09,13.24c-2.2,1-3.14,3.7-3.1,6.12s.82,4.77,1,7.18c.17,1.86,0,3.75.34,5.59a5.72,5.72,0,0,0,3.08,4.41,5,5,0,0,0,5.32-1.52A10.37,10.37,0,0,0,76.84,218c.91-5.59-.28-11.42,1.13-16.91a55.07,55.07,0,0,1,3.53-8.54C82.75,189.73,83.79,186.69,83.53,183.62Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.9,183.22a10.78,10.78,0,0,1-9-16.59,2.77,2.77,0,0,1,1.23-1.19c1.13-.45,2.32.47,3.19,1.33l6.33,6.16",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.08,175.32c-4.75-2.25-8.49-7.58-9.87-12.65s.21-15.34,1.57-20.41c1.67-6.18,4.24,1.77,6.34,2.42a4.08,4.08,0,0,1,2.5,2.82,11.93,11.93,0,0,1,.29,3.91q-.42,12-.83,23.91",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.23,124.94c7.94-4.27,14.32-1.75,17.42.67s5,6.12,6.11,9.89,1.63,7.69,2.55,11.52a47.31,47.31,0,0,1,1.23,6.7c.45,3.27.3,9.12-1.37,12a19.6,19.6,0,0,1-6,6.92c-1,.63-2.09,1.29-3.18.94a3.83,3.83,0,0,1-1.8-1.65,153.26,153.26,0,0,1-20.09-40.16",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.38,134.12l13.76-5.55,3.61.4c8.1,0,13.73,8.9,13.82,15.47.09,7.29-.08,16.2-1.21,21.58-2.28,10.82-10.71,11.79-10.71,11.79s.1,2.95.18,6.58a11.44,11.44,0,0,1-11.68,11.72h0A11.44,11.44,0,0,1,81.93,184.7l-.18-46.87A3.84,3.84,0,0,1,85.38,134.12Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.06,151.66a1.4,1.4,0,0,1-1.42,1.34,1.34,1.34,0,0,1-1.38-1.33,1.41,1.41,0,0,1,1.42-1.35A1.35,1.35,0,0,1,113.06,151.66Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.69,148.16c-.18.17-1.2-.66-2.7-.73s-2.65.62-2.81.43.12-.41.62-.73a3.82,3.82,0,0,1,2.25-.58,3.74,3.74,0,0,1,2.15.82C113.64,147.75,113.78,148.08,113.69,148.16Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.5,159.94a10.45,10.45,0,0,1,2.47-.32c.38,0,.75-.07.83-.33a2.05,2.05,0,0,0-.2-1.16c-.31-.94-.64-1.94-1-3-1.37-4.25-2.34-7.73-2.17-7.78s1.42,3.34,2.79,7.59c.33,1,.64,2,.94,3a2.2,2.2,0,0,1,.13,1.51,1,1,0,0,1-.66.54,2.64,2.64,0,0,1-.66.05A9.37,9.37,0,0,1,104.5,159.94Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.65,177.81a27.83,27.83,0,0,1-14.41-4.63s3.51,7.75,14.48,7.28Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.54,163.2a2.73,2.73,0,0,0-2.43-1.28,2.16,2.16,0,0,0-1.76.84,1.92,1.92,0,0,0-.11,2.05,2,2,0,0,0,2.05.8,5,5,0,0,0,2-1.08,1.64,1.64,0,0,0,.45-.46A1.2,1.2,0,0,0,103.54,163.2Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100,160.76c.24,0,.17,1.63,1.51,2.86s3.08,1.14,3.09,1.37-.41.3-1.14.28a4.08,4.08,0,0,1-2.59-1.05,3.56,3.56,0,0,1-1.16-2.39C99.71,161.14,99.91,160.75,100,160.76Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.48,144c-.28.33-1.3-.07-2.55-.15s-2.31.11-2.54-.26c-.1-.18.09-.51.56-.81a3.69,3.69,0,0,1,4.1.33C113.48,143.43,113.6,143.79,113.48,144Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.43,151.57A1.39,1.39,0,0,0,97.76,153a1.34,1.34,0,0,0,1.46-1.24,1.4,1.4,0,0,0-1.33-1.43A1.33,1.33,0,0,0,96.43,151.57Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.61,148c.17.19,1.24-.58,2.75-.56s2.6.79,2.76.61-.09-.41-.56-.77a3.77,3.77,0,0,0-2.22-.71,3.72,3.72,0,0,0-2.19.67C93.68,147.57,93.52,147.9,93.61,148Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.26,143.21c.26.34,1.31,0,2.56,0s2.3.26,2.55-.1c.11-.17-.06-.51-.51-.84a3.51,3.51,0,0,0-2.07-.59,3.61,3.61,0,0,0-2.05.66C94.3,142.69,94.15,143,94.26,143.21Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.56,127.41c-3.49-1.41-8.82-.93-11.81,1.34a15.43,15.43,0,0,0-5.54,9.52c-.69,3.7.23,9.17,1.2,12.8C87.05,143.8,92.86,135.42,98.3,128Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.22,124.11c19.12-2.7,17.35,26.21,17.35,26.21h0c-1.91-10.65-16.73-21.79-16.73-21.79l-3-.51Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M82.94,156.26c0-.81-.8-2.77-1.6-2.94-2.13-.44-6-.46-6.3,5-.43,7.43,7.12,6.32,7.15,6.11S82.81,159.07,82.94,156.26Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81.07,161.46s-.14.09-.36.18a1.32,1.32,0,0,1-1,0,3.21,3.21,0,0,1-1.32-3,4.27,4.27,0,0,1,.47-1.83,1.51,1.51,0,0,1,1-.94.65.65,0,0,1,.74.4c.09.21,0,.36.07.37s.17-.11.13-.42a.9.9,0,0,0-.27-.49,1,1,0,0,0-.7-.23,1.82,1.82,0,0,0-1.42,1.08,4.34,4.34,0,0,0-.57,2c0,1.5.65,2.94,1.71,3.31a1.34,1.34,0,0,0,1.19-.13C81,161.64,81.09,161.48,81.07,161.46Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.2,138.48a26.82,26.82,0,0,1,10.23-12.39,18.14,18.14,0,0,1,8-3.38,9.2,9.2,0,0,1,8,2.68l.53.54c-3.28,7.29-5.6,13.46-9.83,20.24-1.56,2.49-2.23,11-2.6,13.89-1.28,9.95-6.73,14.21-6.73,14.21C70,174.28,72.3,143.58,74.2,138.48Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80,173.1a3.25,3.25,0,0,1-1.47-.46,10.06,10.06,0,0,1-3-2.24,9.65,9.65,0,0,1-2-3.16,3.27,3.27,0,0,1-.33-1.5,19.4,19.4,0,0,0,2.66,4.31A19,19,0,0,0,80,173.1Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.55,182.78a5.71,5.71,0,0,1-5-3.77,31,31,0,0,0,2.26,2.22A26.85,26.85,0,0,0,78.55,182.78Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.58,191.91c-.11.09-.79-.66-1.52-1.67s-1.21-1.9-1.09-2,.79.66,1.52,1.67S73.7,191.83,73.58,191.91Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.75,203.17c-.11.09-.63-.33-1.17-.95s-.89-1.19-.78-1.29.63.33,1.17.95S69.86,203.07,69.75,203.17Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72,155.31a11.19,11.19,0,0,1,1.41-.82c.46-.25,1-.55,1.65-1s1.38-.79,2.14-1.33a51.25,51.25,0,0,0,5.24-3.93,50.64,50.64,0,0,0,10.36-12.17,52,52,0,0,0,3.05-5.8c.41-.84.69-1.63,1-2.32s.5-1.29.67-1.79a9.92,9.92,0,0,1,.59-1.52,10.42,10.42,0,0,1-.4,1.59,18.62,18.62,0,0,1-.59,1.82c-.25.7-.51,1.51-.9,2.37a47.41,47.41,0,0,1-3,5.9,52.65,52.65,0,0,1-4.71,6.58,52.31,52.31,0,0,1-5.75,5.71,47.57,47.57,0,0,1-5.35,3.87c-.78.52-1.54.91-2.19,1.28s-1.23.65-1.71.87A10.18,10.18,0,0,1,72,155.31Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.41,146.4s-.17.28-.54.71-1,1-1.7,1.74A36.37,36.37,0,0,1,74.45,157a24,24,0,0,1-2.34.65,3.38,3.38,0,0,1-.88.14,31.3,31.3,0,0,1,3.1-1.13,46.07,46.07,0,0,0,7.16-3.4,45.55,45.55,0,0,0,6.44-4.63C89.46,147.24,90.35,146.34,90.41,146.4Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.16,155.9a13,13,0,0,1,.31-1.63,27.25,27.25,0,0,0,.49-4.46,25.92,25.92,0,0,0-14.18-24.14,27.1,27.1,0,0,0-4.14-1.74,13.71,13.71,0,0,1-1.57-.53s.15,0,.43.06.68.12,1.2.27a23.4,23.4,0,0,1,4.24,1.61,25.55,25.55,0,0,1,14.39,24.48,23.44,23.44,0,0,1-.66,4.49c-.12.52-.27.92-.35,1.19A1.54,1.54,0,0,1,118.16,155.9Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M206.78,223.5a2.39,2.39,0,0,0-.33,2.32,3.77,3.77,0,0,0,1.48,1.51,13,13,0,0,0,2.46-3.52",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M202.44,222.23a2.41,2.41,0,0,0-.9,2.17,3.71,3.71,0,0,0,1.06,1.83,13.19,13.19,0,0,0,3.26-2.79",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.82,189.26s32.89,25.88,38.82,26.73,33.67-2.52,45.06-2.87l1.61,9.55s-31.43,10.67-42.86,11.09-18-2.66-18-2.66l-21.37-21.89Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187,213.22s14.69-2.1,17-.95,8.84,6.68,8.84,6.68,2.19,6.15.81,6.44-2.8-2-2.8-2L208.94,220l-8.21-2-13.61,1.21Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M189.31,222.67c.21.26,5.46,2.79,8.13,2.72s5.72-2.16,8-1.84,7.06.69,7.64-.14a1.81,1.81,0,0,0,0-2.52c-.78-.74-4.63-1.47-7.41-2.22a11.12,11.12,0,0,1-4.12-1.89l-16.17,1.78-.92,5Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M196.3,216.61a3.19,3.19,0,0,1,.85-.06,12.46,12.46,0,0,1,2.29.28,64.08,64.08,0,0,1,7.22,2.29,22.3,22.3,0,0,0,4,.94,3.37,3.37,0,0,1,1.79.69,2,2,0,0,1,.6,1.6,1.79,1.79,0,0,1-.67,1.23,1.87,1.87,0,0,1-1,.37c-.58,0-.85-.18-.84-.2a4.49,4.49,0,0,0,.82,0,1.57,1.57,0,0,0,1.3-1.43,1.53,1.53,0,0,0-.52-1.24,3.06,3.06,0,0,0-1.57-.55,20.14,20.14,0,0,1-4.09-.92c-2.82-.94-5.27-2-7.14-2.42S196.3,216.71,196.3,216.61Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M206.89,219.66a4.7,4.7,0,0,1-2.38-1.2c-1.17-.92-1.83-2-1.72-2s.93.75,2,1.62S207,219.52,206.89,219.66Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M75.48,385.39,45.67,398.66l3.59,15.92S86.74,403.4,99,400.92s32.13-5.64,37.74-17.54Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.12,414.87l-1,.28s-2.4,19.54-5.7,20.62l-9.14-35.1,11.64-3.25A22.39,22.39,0,0,0,52.12,414.87Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.24,400.67l2.84-.62,7.72,33.87s-.27,1.74-1.42,1.85Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.63,383.84a4,4,0,0,1-.31.84,10.15,10.15,0,0,1-1.43,2.13,33.22,33.22,0,0,1-7.36,5.86,34,34,0,0,1-5.9,2.77,65.39,65.39,0,0,1-7.19,2c-5.08,1.28-10.66,2.74-16.51,4.29l-30,7.91L58.85,412l-2.48.6a5.19,5.19,0,0,1-.88.17,6.25,6.25,0,0,1,.85-.28l2.46-.68,9.06-2.48c7.66-2.08,18.23-5,29.94-8.06,5.85-1.55,11.43-3,16.53-4.26a66.89,66.89,0,0,0,7.15-2,34.68,34.68,0,0,0,13.25-8.35A11.24,11.24,0,0,0,136.63,383.84Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.28,256l.68,5.87s-10.33,19.51-10.33,30-4.76,93.81-4.76,93.81,56,3.19,61.91-2.28l5.92-5.46,20-5.46-31.25-114v-6.11Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.59,284.24a.81.81,0,0,1,.06.24l.11.68c.09.64.21,1.52.37,2.63.33,2.33.79,5.63,1.36,9.68,1.16,8.17,2.9,19.43,5.15,31.82s4.57,23.55,6.35,31.61c.89,4,1.61,7.24,2.13,9.54l.57,2.6c.05.27.1.49.13.67a.74.74,0,0,1,0,.24,1,1,0,0,1-.08-.22l-.18-.67c-.17-.63-.39-1.49-.67-2.57-.57-2.24-1.36-5.48-2.29-9.51-1.87-8-4.25-19.2-6.51-31.6s-3.92-23.68-5-31.86c-.54-4.09-.94-7.41-1.19-9.71-.12-1.11-.21-2-.28-2.64,0-.28,0-.5-.06-.69A.78.78,0,0,1,127.59,284.24Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.37,294.68a3.73,3.73,0,0,1,.24.66q.21.74.57,1.92c.5,1.73,1.2,4.12,2.06,7.06,1.77,5.95,4.33,14.13,7.45,23.07s6.24,16.94,8.57,22.69c1.16,2.83,2.11,5.14,2.79,6.81l.75,1.85a5.58,5.58,0,0,1,.23.66,2.89,2.89,0,0,1-.33-.62l-.84-1.81c-.72-1.58-1.73-3.88-2.94-6.75-2.42-5.72-5.58-13.7-8.72-22.65s-5.63-17.17-7.31-23.15c-.84-3-1.49-5.42-1.91-7.11-.2-.8-.35-1.44-.47-1.94A4.21,4.21,0,0,1,87.37,294.68Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.39,261.19a9.46,9.46,0,0,1-1.68.2c-1.08.11-2.65.22-4.6.34-3.88.23-9.26.44-15.19.47s-11.32-.15-15.21-.35c-1.94-.1-3.51-.2-4.6-.29a9.46,9.46,0,0,1-1.68-.2,13,13,0,0,1,1.69,0l4.61.13c3.88.11,9.25.22,15.18.2s11.3-.18,15.19-.32l4.6-.17A10.44,10.44,0,0,1,133.39,261.19Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.72,185.06c-.27-.63,19.86,15.42,22.39,23.24s3,30.38,3,30.38l1.41,14.48L91.29,256l-1.08-2.84-3-8.07L83.1,232.9s-9.91-15.39-11.88-22c-2.44-8.23,1.61-16.66,1.61-16.66L81.92,184Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M81.93,184.7s-2.23-4.13-.86-5.94c1.1-1.43,20.45.37,24.4,1.2,2.32.5,0,5.67,0,5.67Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.52,204.2c1.69,4.37-.7,17.92-1.06,21.14a55.18,55.18,0,0,1-2.22,9.47c-.44,1.45-.86,3.11,0,4.38,1.32,2,4.72,1.46,6.37,3.26a15.85,15.85,0,0,1-9.9,1.14,2.7,2.7,0,0,1-1.57-.75,2.85,2.85,0,0,1-.48-1.27,37.66,37.66,0,0,1-.47-14.42C85.06,222.4,89.6,211,93.42,208",
    transform: "translate(-28.76 -42.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.23,210.19a13.19,13.19,0,0,1-1.94,4.64,12.58,12.58,0,0,1-3.19,3.88c-.11-.1,1.34-1.8,2.75-4.15S94.08,210.13,94.23,210.19Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M105.47,185.13a3,3,0,0,1-.92.26c-.6.13-1.47.28-2.56.43A47.54,47.54,0,0,1,85,185c-1.07-.25-1.92-.49-2.5-.68a3.12,3.12,0,0,1-.89-.35c0-.08,1.33.26,3.47.67a60.54,60.54,0,0,0,8.42,1,61.77,61.77,0,0,0,8.49-.19C104.12,185.26,105.45,185.05,105.47,185.13Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.63,224c-.09,0,.26-1.11.53-2.9a21.7,21.7,0,0,0-2.42-13.65c-.87-1.59-1.57-2.48-1.5-2.54s.23.19.56.58a13.33,13.33,0,0,1,1.26,1.78,19.74,19.74,0,0,1,2.47,13.9,13.9,13.9,0,0,1-.58,2.1A2.41,2.41,0,0,1,119.63,224Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,185.82a69.72,69.72,0,0,1-10-1.42,26.54,26.54,0,0,0,15.38,3.09c1.94-.25,4-.79,5.26-2.26C100.69,186.38,96.16,186.1,93,185.82Z",
    transform: "translate(-28.76 -42.51)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.68,228.6a17.66,17.66,0,0,0,4.69-14.37,20,20,0,0,1,.75,5.22,8.82,8.82,0,0,1-1.41,5.78c-1.23,1.69-1.94,2.71-4,3.37",
    transform: "translate(-28.76 -42.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.66,195.41a10,10,0,0,0-14.28,1.34c-.14.18-.28.38-.41.57-2.09,3.13-7.85,51.88-5.55,57.72s5.63,5.43,5.63,5.43,15.08-.17,25.93-2.68,22.94-6.61,22.94-6.61l-2-11.81s-26.56,3.52-33.86,2.69h0l2.79-23.74s6.35-7.73,4.53-14.82C92.5,200.13,90,197.37,87.66,195.41Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128.29,232.12l6-4,4.29-3.62a4.85,4.85,0,0,1-.81,3.81c-1.33,2-3.57,5-3.57,5Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.18,229.7c-.05,0,.34-.46.76-1.32a5.81,5.81,0,0,0,.38-3.82l.36.1-4.27,3.65h0l-.32.21-3.76,2.51a35.39,35.39,0,0,1-3.14,1.94,22,22,0,0,1-3,1.56,21.54,21.54,0,0,1,2.83-1.88c.91-.53,1.93-1.24,3.07-2l3.73-2.53.32-.22,0,0,4.31-3.59.29-.23.07.34a5.79,5.79,0,0,1-.58,4.07,5.09,5.09,0,0,1-.68.93C137.31,229.62,137.2,229.72,137.18,229.7Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.13,242.18c.2-.4,15.88-17.87,19.75-22.18a1.66,1.66,0,0,1,2-.37h0a1.67,1.67,0,0,1,.5,2.61l-20.08,22.33Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.82,234.55c.65-.87-.31-2.58-1.2-3.05s-4.44,1.49-4.44,1.49l-1.28.12s-6.89-1.4-7.12-1.28a21.91,21.91,0,0,0-5,3A9.78,9.78,0,0,0,122,237c-.52.81-1.81,2.13-4.81,2.85l2.92,11.87s6.41-1.51,6.89-1.52,5.85-.43,6.56-.55a17.8,17.8,0,0,0,6-2.77c2.3-1.71,1.23-3.16,1.23-3.16,2.37-1.61.52-3.21.52-3.21l.67-1.14c1-1.81-1-2.81-1-2.81A17.35,17.35,0,0,0,142.82,234.55Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M138.06,238.23c0-.13.71-.47,1.56-1s1.5-1,1.6-.94-.43.79-1.35,1.35S138.1,238.36,138.06,238.23Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.07,241.46c-.08-.11.16-.45.55-.76s.77-.49.85-.39-.16.44-.55.76S140.16,241.56,140.07,241.46Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.37,244.09c0-.14.38-.28.85-.46s.86-.33.94-.23-.23.47-.77.68S139.37,244.22,139.37,244.09Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M137.18,233a13.22,13.22,0,0,1-3.62.51,24.57,24.57,0,0,1-3.65.2c0-.16,1.58-.58,3.61-.72A12.63,12.63,0,0,1,137.18,233Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M86.4,241.84a17.63,17.63,0,0,1-2.66,3.42,17.69,17.69,0,0,1-3.06,3.08,19.24,19.24,0,0,1,2.67-3.42A18.75,18.75,0,0,1,86.4,241.84Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.14,209.6s.07-.53.16-1.48a13.07,13.07,0,0,0-.19-4A14.72,14.72,0,0,0,85,194.27a9.54,9.54,0,0,0-7-.45,7.85,7.85,0,0,0-4.57,3.49,13.07,13.07,0,0,0-1.43,3.75,12.52,12.52,0,0,1-.35,1.45s0-.13,0-.39.06-.62.15-1.1A12.15,12.15,0,0,1,73,197.13a7.66,7.66,0,0,1,1.84-2.21,9.16,9.16,0,0,1,2.9-1.56,9.93,9.93,0,0,1,7.4.44A14.74,14.74,0,0,1,93.47,204a11.67,11.67,0,0,1,0,4.1,8.43,8.43,0,0,1-.24,1.1A1.15,1.15,0,0,1,93.14,209.6Z",
    transform: "translate(-28.76 -42.51)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M167.31,162.34h-41a3.06,3.06,0,0,0-3,3v39.74a3.06,3.06,0,0,0,3,3.05h15.1l5.89,8.35,5.12-8.35h14.89a3,3,0,0,0,3.05-3.05V165.39A3,3,0,0,0,167.31,162.34Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.31,162.34a2.57,2.57,0,0,1,1.21.2,3.29,3.29,0,0,1,1.21.89,3.13,3.13,0,0,1,.71,1.93c0,3.11,0,7.62.07,13.28s0,12.54.06,20.31c0,2,0,4,0,6a3.31,3.31,0,0,1-1.41,2.86,3.25,3.25,0,0,1-1.6.57c-.57,0-1.08,0-1.62,0H152.42l.21-.12-5.11,8.36-.2.33-.22-.31-5.91-8.36.22.11H130.82c-1.65,0-3.23,0-4.91,0a3.29,3.29,0,0,1-2.22-1.27,3.55,3.55,0,0,1-.69-2.41q0-4.78,0-9.42c0-6.17,0-12.12,0-17.8,0-2.83,0-5.6,0-8.29,0-1.34,0-2.67,0-4a3.26,3.26,0,0,1,2.41-3,7.94,7.94,0,0,1,1.92-.11h5.43l6.73,0,20.32.08,5.53,0,1.43,0a4.45,4.45,0,0,1,.49,0s-.16,0-.49,0l-1.43,0-5.53,0-20.32.09H127.38a8.24,8.24,0,0,0-1.81.11,2.81,2.81,0,0,0-2.08,2.6v4c0,2.69,0,5.46,0,8.29,0,5.68,0,11.63,0,17.8v9.42a3.07,3.07,0,0,0,.58,2.1,2.8,2.8,0,0,0,1.87,1.06c1.55.05,3.23,0,4.85,0h10.72l.08.11,5.89,8.36h-.42l5.12-8.35.07-.12h.14L166,208c.53,0,1.09,0,1.59,0a2.9,2.9,0,0,0,1.37-.49,2.85,2.85,0,0,0,1.23-2.49c0-2.06,0-4.06,0-6,0-7.77,0-14.62.06-20.31s0-10.16.07-13.28a3,3,0,0,0-1.8-2.74A4,4,0,0,0,167.31,162.34Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.68,191.33l-.28,0h-.81l-3,0-10,0h-.08v-.08c-.08-.53-.16-1.09-.24-1.66-.67-4.85-1.27-9.18-1.66-12l.06.06-2.66,0h-.71l-.25,0,.25,0H135l2.66,0h.05v0c.41,2.83,1,7.16,1.73,12,.08.56.16,1.13.23,1.66l-.09-.09,10,0,3,0h.81A1.58,1.58,0,0,1,153.68,191.33Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.49,191.62a.17.17,0,0,1-.15-.15l-1.88-13.55-3.17,0c-.28,0-.41,0-.42-.19s.14-.2.42-.21H135l2.72,0a.18.18,0,0,1,.18.16l1.94,13.48,13.56.06c.33,0,.45,0,.46.19h0c0,.18-.13.19-.46.2l-.8,0-3,0-10.09,0Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.19,188.43h.28l.8,0,3,0,10.38-.05-.09.08c.31-1.75.64-3.64,1-5.6.18-1,.35-2,.52-2.94l.09.11H142.93l-3.63,0h0l3.63,0,12.24-.05h.11l0,.11c-.16,1-.34,1.93-.51,2.94-.35,2-.68,3.85-1,5.6v.07h-.08l-10.38,0-3,0h-1.08Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.2,188.62a.19.19,0,0,1-.19-.19c0-.17.18-.18.24-.19l1,0,3,0,10.16-.05,1.4-8-16.77-.06c-.09,0-.27,0-.27-.19s.18-.18.26-.19l1.24,0,6.18,0,9.8,0a.17.17,0,0,1,.14.07.18.18,0,0,1,0,.14l-1.53,8.72a.18.18,0,0,1-.18.15l-14.5-.06Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.13,195.16a2.82,2.82,0,0,1-.08-.33,1.47,1.47,0,0,0-.52-.73,1.34,1.34,0,0,0-2.13,1.07,1.33,1.33,0,0,0,2.13,1.06,1.45,1.45,0,0,0,.52-.73c.06-.21.06-.34.08-.34a1,1,0,0,1,0,.36,1.42,1.42,0,0,1-.51.82,1.53,1.53,0,1,1,.51-1.53A.93.93,0,0,1,143.13,195.16Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.47,196.82a1.36,1.36,0,0,1-.32-.08,1.68,1.68,0,0,1-1.12-1.57,1.7,1.7,0,0,1,1.12-1.58,1.65,1.65,0,0,1,1.57.26,1.67,1.67,0,0,1,.58.93,1.16,1.16,0,0,1,0,.38,1.23,1.23,0,0,1,0,.39,1.62,1.62,0,0,1-1.83,1.27Zm.43-2.79a1.15,1.15,0,0,0-.57.07,1.13,1.13,0,0,0-.74,1.07,1.14,1.14,0,0,0,.74,1.07,1.19,1.19,0,0,0,1.09-.15,1.27,1.27,0,0,0,.45-.64q0-.16.06-.24v-.09l-.06-.24a1.18,1.18,0,0,0-.45-.63A1.12,1.12,0,0,0,141.9,194Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.19,195.15s0-.12-.09-.33a1.34,1.34,0,0,0-.51-.73,1.33,1.33,0,0,0-2.13,1.06,1.34,1.34,0,0,0,2.13,1.07,1.45,1.45,0,0,0,.52-.73c.06-.21.06-.34.08-.34a1,1,0,0,1,0,.35,1.37,1.37,0,0,1-.51.82,1.46,1.46,0,0,1-1.4.24,1.49,1.49,0,1,1,1.4-2.58,1.45,1.45,0,0,1,.51.82A.93.93,0,0,1,152.19,195.15Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.53,196.81a2.14,2.14,0,0,1-.32-.08,1.67,1.67,0,0,1,0-3.15,1.63,1.63,0,0,1,1.57.26,1.57,1.57,0,0,1,.57.92,1,1,0,0,1,0,.39,1.24,1.24,0,0,1,0,.39,1.64,1.64,0,0,1-1.83,1.27ZM151,194a1.27,1.27,0,0,0-.57.06,1.15,1.15,0,1,0,1.09,2,1.19,1.19,0,0,0,.45-.64,2.07,2.07,0,0,0,.06-.24v-.08c0-.05,0-.14-.06-.24a1.19,1.19,0,0,0-.45-.64A1.24,1.24,0,0,0,151,194Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.33,181.33a4.72,4.72,0,1,1-4.72-4.72A4.73,4.73,0,0,1,160.33,181.33Z",
    transform: "translate(-28.76 -42.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "124.14 138.91 124.85 138.21 126.21 139.42 128.89 136.85 129.54 137.55 126.11 140.78 124.14 138.91"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/Buy.77bf259dddd520d2a909399de2c1d0e8.svg";
export { ForwardRef as ReactComponent };